<!--
 * @Description: 新增交叉分析报表
 * @Version: 1.0
 * @Autor: jinchuan.lee
 * @Date: 2021-05-31 15:28:57
 * @LastEditors: jinchuan.lee
 * @LastEditTime: 2021-06-15 17:10:32
-->
<template>
    <transition name='dialogShow'>
        <div class="newAdd-crossAnalysis" v-show='isDialogShow'>
            <div class="newAdd-crossAnalysis-header">
                <!-- close -->
                <div @click="isDialogShow = false" class="newAdd-crossAnalysis-close">
                    <i class="el-icon-arrow-right"></i>
                    <span>收起</span>
                </div> 
                <!-- operation -->
                <div>
                    <accBtn type="3" text="取消配置" size = "mini" width = "80px" @click="handleDeleteAll"></accBtn>
                    <accBtn text="保存" size = "mini" width = "80px" @click='handleSave'></accBtn>
                </div>
            </div>
            <!-- name  -->
            <div class="newAdd-crossAnalysis-title">
                <el-input size="small" v-model="form.name" placeholder="报表名称" class="acc-input-noBorder"></el-input>
            </div>
            <!-- 字段title -->
            <div  class="newAdd-crossAnalysis-listTitle">
                <div 
                    class = "newAdd-crossAnalysis-listTitle-title color333 size16 bold"
                > 
                    分析对象
                </div>
                 <!-- search -->
                <div class="newAdd-crossAnalysis-search" >
                    <!-- <img 
                        src="/static/icon/acc-search-icon.png" 
                        alt="搜索" 
                        class="newAdd-crossAnalysis-search-icon pointer" 
                        @click = "isSearchShow = true"
                    > -->
                    <el-input 
                        size="mini" 
                        v-model="searchName"
                        clearable
                        prefix-icon="el-icon-search"
                        @input = "handleSearch" 
                        placeholder="搜索需要分析对象" 
                    >
                    </el-input>
                    <!-- <img 
                        src="/static/icon/acc-close-icon.png" 
                        alt="清空" 
                        class="newAdd-crossAnalysis-search-clearIcon pointer" 
                        @click = "clearSearch"
                    > -->
                </div>
            </div>
            <!-- 源字段 -->
            <div class="newAdd-crossAnalysis-list top10 br4 pd10">
                <draggable
                    v-model='fieldList'
                    class="newAdd-crossAnalysis-list-wrapper"
                    @choose='handleItemChoose($event,true)'
                    @unchoose='handleItemChoose($event,false)'
                    :group='dragConfig("1")'
                >
                    <div  
                        class="newAdd-crossAnalysis-list-items color333 br2"
                        v-for='i in fieldList' 
                        :key='i.id' 
                         @click.stop = "()=>{}"
                        :customType = 'i.customTypes'
                    >
                        <img 
                            :src="'/static/icon/'+(i.customTypes==='1'?'text_s.png':i.customTypes==='2'?'date_s.png':i.customTypes==='3'?'number_s.png':'select_s.png')"
                            alt="" 
                            class="newAdd-crossAnalysis-list-items-icon"
                        >
						<span class="newAdd-crossAnalysis-list-items-label textOver" :title="i.name">{{i.name}}</span>				
                    </div>
                </draggable> 
                <div v-if = "!fieldList.length" class="color999 center top30 size16">
                    暂无数据
                </div>
            </div>
            <!-- 查看配置 -->
            <div class="newAdd-crossAnalysis-seeSetting top10 pointer" @click.stop = "handleOpenSetting">
                <img src="/static/icon/cashierdiary_look.png" alt="" class="newAdd-crossAnalysis-seeSetting-eyes">
                <span class="newAdd-crossAnalysis-seeSetting-title">{{ isOpenSetting?"关闭":"查看" }}当前配置</span>
            </div>
            <!-- 提示图片 -->
            <div class="newAdd-crossAnalysis-tips">
                <div class="newAdd-crossAnalysis-tips-title color333 size16 bold">如何配置报表</div>
                <img src="/static/img/c-crossAnalysis.gif" alt="" class="newAdd-crossAnalysis-tips-img top10">
            </div>
        </div>
    </transition>
</template>
<script>
import draggable from "vuedraggable"
import config from "./dragConfig.js"
export default {
    props: {
        drawer:Boolean,
        formData:Object,
        tabName:String
    },
    components: {
        draggable
    },
    data() {
        return {
            isOpenSetting: false,
            dragConfig:config.getDragConfig,  // 拖动配置
            form: {
                name:"",  // 报表名称
                id:""
            },
            fieldList: [],  // 所有字段值
            _fieldList:[],  // 所有字段复制值
            searchName:"", // 搜索值
            isSearchShow: false,  // 是否显示搜搜框
        }
    },
    computed: {
        isDialogShow:{
            get() {
                return this.drawer;
            },
            set(val){
                this.$emit('update:drawer',val);
            }

        }
    },
    created() {
    },
    watch:{
        drawer(val) {
            if(val) {
                if(this.tabName) this.form.name = this.tabName;
                this.getAllDataList();
            }
        }
    },
    methods:{
        /**
         * @description: 清空数据
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        clearData() {
            for(var i in this.form) {
                this.form[i] = "";
            }
        },
        /**
         * @description: 保存报表
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleSave() {
            this.$emit('saveReportForm',this.form)
        },
        /**
         * @description: 查看配置
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleOpenSetting() {
            this.isOpenSetting = !this.isOpenSetting;
            this.$emit('openSetting',this.isOpenSetting)
        },
        /**
         * @description: 取消配置
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleDeleteAll() {
            this.$confirm('是否取消当前配置?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.isDialogShow = false;
                this.form.name = "";
                // 告诉父组件点击取消按钮
                this.$emit('deleteItem',true);
            })
		},
        /**
         * @description: 隐藏搜索框  手动重置可选项
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        clearSearch() {
            this.isSearchShow = false;
            this.searchName = '';
            this.handleSearch("");
        },
        /**
         * @description: 搜索触发
         * @param {*} e
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleSearch(e) {
            this.fieldList = this._fieldList.filter(i => { return i.name.indexOf(e) !== -1 }); 
        },
        /**
         * @description: 鼠标按住&&松开
         * @param {*} e  鼠标按住&&松开 对象
         * @param {*} type  true 按住  false 松开
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleItemChoose(e,type) {
            let params = {
                customtype: e.item.attributes.customtype.value.trim(),
                itemName: e.item.innerText.trim(),
                isHold: type,
                id:"all"
            }
            this.$emit("itemHold",params)
        },
        /**
         * @description: 请求所有字段
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        getAllDataList() {
            this.dialogLoading = true;
            let params = JSON.parse(JSON.stringify(this.formData));
            params.displayZero = params.displayZero?1:0;
            this.$http.post('analysis/findCustomColumn',params).then(res=>{
                this.dialogLoading = false;
                    if(res&&res.data.code==1) {
                        let data = res.data.data.map(i=>{
                            i.value="";
                            i.isAnimationShow=false;
                            i.isShowLine = false;
                            if(i.customTypes==="3"){
                                i.value='np.sum';
                            }
                            return i;
                        });
                        this.fieldList = data;
                        this._fieldList = this.$lodash.cloneDeep(data);
                    }
                })
        },
    }
}
</script>
<style scoped lang="less">
    .newAdd-crossAnalysis {
      width: 4.24rem;
      height: calc(100% - 60px);
      background-color: #fff;
      box-shadow: -4px 0px 6px 0px rgba(0, 0, 0, 0.1);
      position: fixed;
      right:0;
      bottom: 0;
      border-radius: 5px;
      z-index: 1500;
      padding: .20rem;
      box-sizing: border-box;
      overflow-y:hidden;
        &-tips {
            margin-top: .5rem;
            &-img {
                width: 100%;
            }
        }
        &-list {
            .acc-border-mix(dashed);
            padding-bottom: 0px;
            height: 2.80rem;
            overflow: auto;
            &-wrapper {
                .acc-flex-mix();
                flex-wrap: wrap;
            }
            &-items {
                padding: 0.07rem .1rem;
                background: #F1F8FF;
                width: 1.7rem;
                box-sizing: border-box;
                margin-bottom: .1rem;
                display: flex;
                align-items: center;
                cursor: pointer;
                &-label {
                    display: inline-block;
                }
                &-icon {
                    width: .16rem;
                    height: .16rem;
                    margin-right: .1rem;
                }
                &:hover {
                    background: darken(#F1F8FF,5%);
                }
            }
        }
        &-close {
            cursor: pointer;
            color: @main-color;
            &:hover {
                color: @main-color-hover;
            }
        }
        &-header {
            .acc-flex-mix();
        }
       
        &-title {
            padding-bottom: 2px;
            border-bottom: 1px solid #666;
            margin-top: .20rem;
            /deep/ .el-input__inner {
                font-size: .22rem;
            }
        }
        &-listTitle {
            margin-top: .4rem;
            .acc-flex-mix();
             padding-bottom: 2px;
            &-title {
                transition: all .5s;
                width: 1rem
            }
        }
        &-seeSetting {
           display: flex;
           align-items: center;
           &-title {
               margin-left: .1rem;
               color: @click-color;
               text-decoration: underline;
           }
        }
        &-search {
            .acc-flex-mix();
            transition: all .5s;
            &-icon {
                width: .2rem;
                height: .2rem;
            }
            &-clearIcon {
                width: .16rem;
                height: .16rem;
                cursor: pointer;
            }
        }
    }
    .dialogShow-enter-active,.dialogShow-leave-active {
    	transition: all .2s linear;
    }
    .dialogShow-enter,.dialogShow-leave-to {
    	opacity: 0;
        transform: translateX(532px);
    }  
</style>




// WEBPACK FOOTER //
// src/pages/cashier/components/crossAnalysis/add-crossAnalysis.vue